import { styled } from 'styles';

export const StyledDatePicker = styled.div`
  .react-date-picker {
    background-color: ${({ theme }) => theme.input.background};
    display: inline-flex;
    position: relative;
    width: 100%;

    .react-date-picker__wrapper {
      align-items: center;
      border: thin solid ${({ theme }) => theme.input.border};
      border-radius: ${({ theme }) => theme.radius.small};
      display: flex;
      flex: 1 0;
      height: ${({ theme }) => theme.element.height}px;
      justify-content: space-between;
      line-height: ${({ theme }) => theme.element.lineHeight};
      outline: none;
      overflow: hidden;
      padding: 0 ${({ theme }) => theme.spacing.relative.smaller};
      transition: border-color ${({ theme }) => theme.transition.medium} ease-in-out,
        box-shadow ${({ theme }) => theme.transition.medium} ease-in-out;

      .react-date-picker__inputGroup {
        align-items: baseline;
        display: flex;

        .react-date-picker__inputGroup__divider {
          padding: 0 ${({ theme }) => theme.spacing.relative.tiny};
        }

        .react-date-picker__inputGroup__input {
          background-color: transparent;
          border: none;
          color: ${({ theme }) => theme.input.color};
          outline: none;
          padding: 0;
          -moz-appearance: textfield;

          &.react-date-picker__inputGroup__input--hasLeadingZero {
            margin-left: -1ch;
            padding-left: 1ch;
            width: 2ch !important;
          }

          &::-webkit-inner-spin-button,
          &::-webkit-outer-spin-button {
            -webkit-appearance: none;
          }

          &:invalid {
            background: ${({ theme }) => theme.datePicker.input.invalid.background};
          }
        }

        .react-date-picker__inputGroup__leadingZero {
          margin-right: -1ch;
          width: 2ch;
        }
      }

      .react-date-picker__button {
        background-color: transparent;
        border: 0;
        cursor: pointer;
        margin: 0;
        padding: 0;

        .react-date-picker__button__icon {
          stroke: ${({ theme }) => theme.datePicker.icon.color};
          transition: stroke ${({ theme }) => theme.transition.medium} ease-in-out;
        }

        &:hover:not(:disabled) {
          .react-date-picker__button__icon {
            stroke: ${({ theme }) => theme.datePicker.icon.hover};
          }
        }

        svg {
          display: inherit;
        }
      }
    }

    .react-date-picker__calendar {
      left: 0;
      max-width: 100vw;
      position: absolute;
      top: 100%;
      width: 100%;

      &.react-date-picker__calendar--closed {
        display: none;
      }
    }

    &.react-date-picker--disabled {
      opacity: 0.5;
    }

    &.react-date-picker--open {
      .react-date-picker__wrapper {
        border-color: ${({ theme }) => theme.input.focus.border};
        border-bottom-color: ${({ theme }) => theme.input.border};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        box-shadow: ${({ theme }) => theme.shadow.highlight};
      }

      .react-date-picker__calendar {
        &.react-date-picker__calendar--open {
          bottom: unset !important;
          top: 100% !important;
        }
      }
    }
  }

  // Calendar
  .react-calendar {
    background-color: ${({ theme }) => theme.input.background};
    border: thin solid ${({ theme }) => theme.input.focus.border};
    border-radius: 0 0 ${({ theme }) => theme.radius.small} ${({ theme }) => theme.radius.small};
    border-top: none;
    box-shadow: ${({ theme }) => theme.shadow.highlight};
    width: 100%;

    button {
      background-color: transparent;
      color: ${({ theme }) => theme.datePicker.calendar.button.color};
      border: none;
      outline: none;
      padding: ${({ theme }) => theme.spacing.relative.smaller}
        ${({ theme }) => theme.spacing.relative.medium};
      transition: background-color ${({ theme }) => theme.transition.fast} ease-in-out,
        border-color ${({ theme }) => theme.transition.fast} ease-in-out,
        color ${({ theme }) => theme.transition.fast} ease-in-out;

      &:disabled {
        opacity: 0.5;
      }

      &:hover:not(:disabled) {
        background-color: ${({ theme }) => theme.datePicker.calendar.button.hover.background};
        cursor: pointer;
      }
    }

    .react-calendar__navigation {
      display: flex;

      button.react-calendar__navigation__arrow {
        padding: 0;
        width: 2.5em;
      }

      button.react-calendar__navigation__label {
        overflow: hidden;

        .react-calendar__navigation__label__labelText {
          display: block;
          font-size: 0.9em;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .react-calendar__month-view__weekdays {
      .react-calendar__month-view__weekdays__weekday {
        font-size: 0.8em;
        font-weight: bold;
        padding: ${({ theme }) => theme.spacing.relative.small}
          ${({ theme }) => theme.spacing.relative.tiny};
        text-align: center;
        text-transform: uppercase;
      }
    }

    .react-calendar__month-view__days {
      button.react-calendar__tile {
        border: thin solid transparent;
        padding: ${({ theme }) => theme.spacing.relative.smaller}
          ${({ theme }) => theme.spacing.relative.small};
        text-align: center;
        width: 100%;

        &.react-calendar__month-view__days__day--weekend {
          color: ${({ theme }) => theme.datePicker.calendar.weekend.color};
        }

        &.react-calendar__month-view__days__day--neighboringMonth {
          color: ${({ theme }) => theme.datePicker.calendar.neighboringMonth.color};
        }

        &.react-calendar__tile--now {
          border-color: ${({ theme }) => theme.datePicker.calendar.today.border};
          color: ${({ theme }) => theme.datePicker.calendar.today.color};
          font-weight: bold;
        }

        &.react-calendar__tile--active {
          background-color: ${({ theme }) => theme.datePicker.calendar.selected.background};
          border-color: ${({ theme }) => theme.datePicker.calendar.selected.border};
          color: ${({ theme }) => theme.datePicker.calendar.selected.color};
        }

        &:disabled {
          background-color: ${({ theme }) => theme.datePicker.calendar.button.disabled.background};
          color: ${({ theme }) => theme.datePicker.calendar.button.disabled.color};
        }

        &:hover:not(:disabled):not(.react-calendar__tile--active) {
          background-color: ${({ theme }) => theme.datePicker.calendar.button.hover.background};
          border-color: ${({ theme }) => theme.datePicker.calendar.day.hover.border};
        }
      }
    }

    .react-calendar__year-view {
      button.react-calendar__year-view__months__month {
        overflow: hidden;

        abbr {
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
`;

StyledDatePicker.displayName = 'DatePicker.Styled';
